import { Box, Button, Divider, Typography } from "@mui/material";
import { useNavigate, useParams, Link } from "react-router-dom";
import { useSnackbar } from "notistack";

import CreatePlanForm, { ICreatePlanForm } from "../partials/form";

import EditPlanStyle from "./style";

import { useUpdatePlan } from "@/api/hooks/usePlans";
import { AvailableCurrency } from "@/api/types";
import { useCheckPermissionAccess } from "@/hooks/useCheckPermissionAccess";
import ROUTE_CONSTANTS from "@/constants/route-constants";
import { OperationAccess, PagesAccess } from "@/constants/enums/permissions";

export default function CreatePlan() {
    const { planId } = useParams();
    const { mutate: updatePlan } = useUpdatePlan();
    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    const editAccess = useCheckPermissionAccess(PagesAccess.PLANS, OperationAccess.UPDATE);

    const handleSubmit = (formData: ICreatePlanForm) => {
        const {
            en_title,
            ar_title,
            en_name,
            ar_name,
            en_subtitle,
            ar_subtitle,
            en_description,
            ar_description,
            en_trialTitle,
            ar_trialTitle,
            en_trialSubtitle,
            ar_trialSubtitle,
            features,
            ...rest
        } = formData;

        if (editAccess) {
            updatePlan(
                {
                    params: { currency: formData.currency as AvailableCurrency, id: Number(planId) },
                    body: {
                        ml_title: { en: en_title, ar: ar_title },
                        ml_name: { en: en_name, ar: ar_name },
                        ml_subtitle: { en: en_subtitle, ar: ar_subtitle },
                        ml_description: { en: en_description ?? "", ar: ar_description ?? "" },
                        ml_trialTitle:
                            en_trialTitle || ar_trialTitle
                                ? { en: en_trialTitle ?? "", ar: ar_trialTitle ?? "" }
                                : undefined,
                        ml_trialSubtitle:
                            en_trialSubtitle || ar_trialSubtitle
                                ? { en: en_trialSubtitle ?? "", ar: ar_trialSubtitle ?? "" }
                                : undefined,
                        ml_features: features,
                        ...rest,
                    },
                },
                {
                    onSuccess: () => {
                        navigate(-1);
                    },
                }
            );
        } else {
            enqueueSnackbar("You don't have the correct rights to Edit a plan.", { variant: "warning" });
        }
    };

    return (
        <EditPlanStyle>
            <Box className="plans-header">
                <Typography className="main-title">Edit a Plan</Typography>
                <Button component={Link} to={ROUTE_CONSTANTS.SETTINGS.PLANS.ROOT.ABSOLUTE}>
                    Back To List
                </Button>
            </Box>
            <Divider />
            <Box className="form">
                <CreatePlanForm planId={Number(planId)} onSubmit={handleSubmit} />
            </Box>
        </EditPlanStyle>
    );
}
